import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import ptBR from "antd/lib/locale/pt_BR";

import { AppThemeProvider, useAppTheme } from "./app/providers/ThemeProvider";
import { AlertProvider } from "./app/providers/AlertProvider";
import AppProvider from "./hooks";
import Routes from "./pages/Routes";
import GlobalStyle from "./styles/GlobalStyle";
import { getAntdThemeConfig } from "./theme";

import "./config/firebase";

function AntdBridge({ children }: { children: React.ReactNode }) {
  const { theme } = useAppTheme();
  return (
    <ConfigProvider locale={ptBR} theme={getAntdThemeConfig(theme.colors)}>
      {children}
    </ConfigProvider>
  );
}

const App: React.FC = () => {
  return (
    <AppThemeProvider>
      <GlobalStyle />
      <div className="app-root">
        <BrowserRouter>
          <AlertProvider>
            <AppProvider>
              <AntdBridge>
                <div className="app-shell">
                  <Routes />
                </div>
              </AntdBridge>
            </AppProvider>
          </AlertProvider>
        </BrowserRouter>
      </div>
    </AppThemeProvider>
  );
};

export default App;
